export const facilityBaseUrl = '/facility-manager/api/';
export const groupsBaseUrl = 'facility-manager/crud/';
